import { SettlementRepositoryImpl } from '../Data/SettlementRepositoryImpl';
import { SearchSettlementsUseCase } from '../Domain/usecases/SearchSettlementsUseCase';
import { GetCommissionSumUseCase } from '../Domain/usecases/GetCommissionSumUseCase';
import { SearchCommissionsUseCase } from '../Domain/usecases/SearchCommissionsUseCase';
import { SearchTransactionsUseCase } from '../Domain/usecases/SearchTransactionsUseCase';

const repository = new SettlementRepositoryImpl();

export const settlementUseCases = {
  searchSettlements: new SearchSettlementsUseCase(repository),
  getCommissionSum: new GetCommissionSumUseCase(repository),
  searchCommissions: new SearchCommissionsUseCase(repository),
  searchTransactions: new SearchTransactionsUseCase(repository),
};

